import React, { Suspense, forwardRef, lazy } from "react";
import { SEPAQ_SHEET } from "@/content/sepaqSheet.js";

const TerritoryMap = lazy(() => import("@/components/TerritoryMap.jsx").then((mod) => ({ default: mod.TerritoryMap })));

/** One map engine. Sépaq HD tiles are the default basemap on every screen. */
export const PWSGroupMap = forwardRef(function PWSGroupMap({ basemap = "official", ...props }, ref) {
  const official = basemap === "official";
  return (
    <Suspense fallback={<p>Carte…</p>}>
      <TerritoryMap
        ref={ref}
        {...props}
        layer={official ? "standard" : basemap}
        sheet={official ? SEPAQ_SHEET : null}
      />
    </Suspense>
  );
});
